/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-support-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-support-api-client";
import type { BulkUploadBcrFilesMutationRequest, BulkUploadBcrFilesMutationResponse } from "../models/BulkUploadBcrFiles";
import { buildFormData } from "../.kubb/config";

export function getBulkUploadBcrFilesUrl() {
  const res = { method: 'POST', url: `/bcr-files/bulk-upload` as const }
  return res
}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload BCR files
 * {@link /bcr-files/bulk-upload}
 */
export async function bulkUploadBcrFiles(data: BulkUploadBcrFilesMutationRequest, config: Partial<RequestConfig<BulkUploadBcrFilesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<BulkUploadBcrFilesMutationResponse, ResponseErrorConfig<Error>, BulkUploadBcrFilesMutationRequest>({ method : "POST", url : getBulkUploadBcrFilesUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}